export const config = {
    apiKey: "AIzaSyDXCJyi6W5rWkao5hHWz9Pr1_7HvrAnRfc",
    authDomain: "vue-final-project-484f8.firebaseapp.com",
    databaseURL: "https://vue-final-project-484f8.firebaseio.com",
    projectId: "vue-final-project-484f8",
    storageBucket: "vue-final-project-484f8.appspot.com",
    messagingSenderId: "787310197725",
    appId: "1:787310197725:web:6e2a142377a7747c6ad434",
    measurementId: "G-KJZPVS8SX0"
};